var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-anchor",
    style: _vm.styles,
    on: {
      "click": _vm.revealTag
    }
  }, [_c('div', {
    staticClass: "tag-anchor__pos"
  }, [_c('div', {
    staticClass: "tag-reveal",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "tag-reveal__inner"
  }, [_vm.label ? _c('div', {
    staticClass: "tag-reveal__content-col",
    attrs: {
      "dir": _vm.language.dir
    }
  }, [_c('div', {
    staticClass: "tag-reveal__label",
    domProps: {
      "innerHTML": _vm._s(_vm.label[_vm.language.code])
    }
  }), _c('div', {
    staticClass: "tag-reveal__description",
    class: {
      'reveal': _vm.isActive
    },
    domProps: {
      "innerHTML": _vm._s(_vm.description[_vm.language.code])
    }
  })]) : _vm._e(), _vm.asset && _vm.asset.type === 'image' ? _c('div', {
    staticClass: "tag-reveal__image-col"
  }, [_c('div', {
    staticClass: "tag-reveal__image-clip"
  }, [_c('img', {
    staticClass: "tag-reveal__asset",
    class: {
      reveal: _vm.isActive
    },
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.asset.path)
    }
  })])]) : _vm._e(), _vm.asset && _vm.asset.type === 'video' ? _c('div', {
    staticClass: "tag-reveal__image-col"
  }, [_c('div', {
    staticClass: "tag-reveal__image-clip"
  }, [_c('video', {
    staticClass: "tag-reveal__asset",
    class: {
      'reveal': _vm.isActive
    },
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath + _vm.asset.path),
      "autoplay": "",
      "muted": "",
      "loop": "",
      "disablePictureInPicture": "",
      "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
    },
    domProps: {
      "muted": true
    }
  })])]) : _vm._e()])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }